import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, of, timer, switchMap, from, EMPTY } from "rxjs";

@Injectable({ providedIn: "root" })
export class OfflinePreloadingStrategy implements PreloadingStrategy {
    preload(route: Route, load: () => Observable<any>): Observable<any> {
        // Only preload when online
        if (!navigator.onLine) {
            return EMPTY;
        }

        // Preload immediately if route has preload: true
        if (route.data?.["preload"] === true) {
            return load();
        }

        // Delay preload for all other routes (after 2s to avoid blocking initial load)
        return timer(2000).pipe(switchMap(() => load()));
    }
}
